import { ValidationSchema } from '../features/edit-group-details/GroupFormPage'

type MinimalPointPeople = { nodes: Array<{ id: string | number; fullName?: string | null }> }

type ServerGroupType = {
  id: string
  name: string
  description: string | null
  venueName?: string | null
  streetAddress?: string | null
  city?: string | null
  postcode?: string | null
  state?: string | null
  country?: string | null
  pointPeople: MinimalPointPeople
  hasPhysicalAddress?: boolean | null
  publicPublish?: boolean | null
  publicDescription?: string | null
  notifyAllAdmins?: boolean | null
}

type ServerInputGroupType<T extends FrontendGroupType> = Omit<T, 'addPointPeople' | 'pointPeople'> & {
  pointPeople: string[]
}

type FrontendGroupType = ValidationSchema['group']

export default class GroupDetailsAdapter<T extends FrontendGroupType> {
  group: T

  constructor(group: T) {
    this.group = group
  }

  static fromServer(group: ServerGroupType) {
    const frontendGroup = {
      ...group,
      hasPhysicalAddress: group.hasPhysicalAddress ?? false,
      publicDescription: group.publicDescription ?? '',
      publicPublish: group.publicPublish ?? false,
      addPointPeople: Boolean(group.notifyAllAdmins || group.pointPeople.nodes?.length),
      notifyAllAdmins: group.notifyAllAdmins ?? false,
      pointPeople: group.pointPeople?.nodes?.map((node) => ({ value: Number(node.id), label: node.fullName || '' })) ?? [],
    }
    return new GroupDetailsAdapter(frontendGroup)
  }

  static fromFrontend<T extends FrontendGroupType>(group: T) {
    return new GroupDetailsAdapter<T>(group)
  }

  toServer() {
    const { addPointPeople, notifyAllAdmins, pointPeople, ...serverType } = this.group

    return {
      ...serverType,
      notifyAllAdmins: Boolean(addPointPeople && notifyAllAdmins),
      pointPeople: addPointPeople && pointPeople ? pointPeople.map(({ value }) => value.toString()) : [],
    } as ServerInputGroupType<T>
  }

  toFrontend(): FrontendGroupType {
    return {
      ...this.group,
    }
  }
}
